/**
 * Firestore Client
 *
 * Initializes and exports the Firestore database instance.
 * Uses the same Firebase app as authentication.
 *
 * Firestore is used for collaboration metadata only:
 * - Space membership and permissions
 * - Invitation system
 * - RSVP tracking
 * - Activity logs
 * - User profiles
 *
 * User content (notes, events) is stored in Google Drive, not Firestore.
 */

import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { app } from './firebase';

// Initialize Firestore using the existing Firebase app
const db = getFirestore(app);

// Connect to emulator in development (optional)
if (import.meta.env.DEV && import.meta.env.VITE_USE_FIRESTORE_EMULATOR === 'true') {
  try {
    connectFirestoreEmulator(db, 'localhost', 8080);
    console.log('[Firestore] Connected to emulator at localhost:8080');
  } catch (error) {
    console.error('[Firestore] Failed to connect to emulator:', error);
  }
}

console.log('[Firestore] Initialized successfully');

export { db };
